import { render, staticRenderFns } from "./TiarcoYearlySalesAnalysisByItemCode.vue?vue&type=template&id=36f72e63"
import script from "./TiarcoYearlySalesAnalysisByItemCode.vue?vue&type=script&lang=ts"
export * from "./TiarcoYearlySalesAnalysisByItemCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports